module.exports = __webpack_public_path__ + "img/uk.736a748d.svg";